<template>
  <div>
    <a-modal
        :width="this.settings['isMobileView'] ? 420 : this.settings['isTabletView'] ? 600 : 840"
        v-model="visible"
        :title="`Add/Update grades mark for ${this.subjectName}`"
        on-ok="handleOk">
      <template slot="footer">
        <a-button key="back" @click="handleCancel">
          Cancel
        </a-button>
        <a-button
          key="submit"
          type="primary"
          :loading="loading"
          @click="handleSubmit"
        >
          Submit
        </a-button>
      </template>
      <p class="text-muted mb-4">Enter the grades corresponding to the roll nos.</p>
        <a-form class="mb-4" :form="form">
          <div class="row neo-exam-mark-form-table-container" v-if="studentList">
            <div class="col-6 col-md-4 col-lg-3" v-for="(student_enrollment, index) in studentList" :key="index">
              <table class="table table-bordered table-sm-responsive">
                <tbody>
                  <tr>
                    <th scope="row" style="min-width:45px;">
                      {{ student_enrollment.enrollment[0].roll_no }}
                    </th>
                    <td>
                      <a-form-item class="d-none">
                        <a-input
                          v-decorator="[`enroll_mark[${student_enrollment.enrollment[0].id}][enroll_Id]`, { initialValue: student_enrollment.enrollment[0].id }]"
                        />
                      </a-form-item>
                      <a-form-item class="m-0">
                        <a-input
                          placeholder=""
                          v-decorator="[`enroll_mark[${student_enrollment.enrollment[0].id}][grade]`, {rules: [{ required: false }] }]"
                          :min="0"
                          :disabled="false"
                          style="width: 100%;"
                        />
                      </a-form-item>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </a-form>
    </a-modal>
  </div>
</template>
<script>
import { makeFieldsData } from '@/components/bosemexam/final/Form/GradeSubmit/gradeFields'
import { mapState } from 'vuex'
export default {
  data() {
    return {
      form: this.$form.createForm(this),
      loading: false,
      visible: false,
      subjectName: null,
      subjectId: null,
      studentList: [],
      setId: null,
      classId: null,
      sessionId: null,
      exams: [],
      section: null,
    }
  },
  mounted: function () {
    this.$eventBus.$on('openClassExamMarksForm', this.showModal)
  },
  beforeDestroy: function () {
    this.$eventBus.$off('openClassExamMarksForm')
  },
  computed: {
    ...mapState(['settings']),
  },
  methods: {
    showModal(subId, name, getclSecStd, settingId, studentGrades, getClassId, session, examsSelected, sectionId) {
      // alert(subId)
      this.subjectId = subId
      this.subjectName = name
      this.studentList = getclSecStd
      this.setId = settingId
      this.studentGradesList = studentGrades
      this.classId = getClassId
      this.sessionId = session
      this.exams = examsSelected
      this.section = sectionId

      this.$nextTick(() => {
        const fieldsData = makeFieldsData(studentGrades, this.subjectId)
        this.form.setFieldsValue(fieldsData)
      })
      this.visible = true
    },
    handleOk(e) {
      this.loading = true
      setTimeout(() => {
        this.visible = false
        this.loading = false
      }, 3000)
    },
    handleSubmit: function (e) {
      // this.loading = true
      this.form.validateFields((err, values) => {
        if (!err) {
          this.$confirm({
            title: `Are you sure?`,
            content: `Click on the OK button to update the details!`,
            onOk: () => {
              // values.class_section_exam_id = this.examData.id
              // values.subject_id = this.subjectData.id
              let formData = {}
              formData.class_id = this.classId
              formData.section_id = this.section
              formData.session_id = this.session_id
              formData.setting_id = this.setId
              formData.subject_id = this.subjectId
              //   formData.exams = this.exams

              formData.enroll_mark = values.enroll_mark.flat().filter(element => {
                if (element) {
                  return true
                } else {
                  return false
                }
              }).map(el => {
                if (!el.hasOwnProperty('grade')) {
                  el.grade = null
                }
                return el
              })
              this.$http
                .post('/api/bosem_final_result_subjects', formData)
                .then(() => {
                  this.$emit('updated')
                  this.loading = false
                  this.visible = false
                  this.$notification['success']({
                    message: 'Successfully updated',
                    description: 'Subject grade marks updated successfully!',
                  })
                })
                .catch(error => {
                  this.loading = false
                  this.$neoNotify.error(error)
                })
            },
            onCancel: () => {
              this.loading = false
            },
          })
        }
      })
    },
    handleCancel(e) {
      this.visible = false
    },
  },
}
</script>
